import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SelfCertificationPageComponent } from './self-certification-page.component';
import { TaxbitFormComponent } from './taxbit-form.component';
import { SelfCertificationApiService } from './self-certification-api.service';

@NgModule({
	declarations: [SelfCertificationPageComponent, TaxbitFormComponent],
	imports: [CommonModule, MatDividerModule, MatProgressSpinnerModule],
	providers: [SelfCertificationApiService],
})
export class SelfCertificationModule {}
